import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message } from 'antd';
import { history } from '@umijs/max';

// 与后端约定的响应数据格式
interface ResponseStructure {
  data: any;
  code?: number;
  msg?: string;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res: any) => {
      const { data, code, msg } = res as unknown as ResponseStructure;
      if (code !== 200) {
        const error: any = new Error(msg);
        error.name = 'BizError';
        error.info = { code, msg, data };
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.name === 'BizError') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { code, msg } = errorInfo;
          // 处理401错误 - token失效
          if (code === 401) {
            // message.error(msg || 'token失效，请重新登录');
            // 清除本地存储的token
            localStorage.removeItem('accessToken');
            // 使用React Router进行无刷新跳转
            history.push('/user/login');
            return;
          }
          // message.error(msg);
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        if (error.response.status === 401) {
          // message.error('token失效，请重新登录');
          // 清除本地存储的token
          localStorage.removeItem('accessToken');
          // 使用React Router进行无刷新跳转
          history.push('/user/login');
          return;
        }
        message.error(`Response status:${error.response.status}`);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        // message.error('None response! Please retry.');
      } else {
        // 发送请求时出了点问题
        // message.error('Request error, please retry.');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 拦截请求配置，进行个性化处理。
      const token = localStorage.getItem('accessToken'); // Corrected key to 'accessToken'
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`; // 通常使用 Bearer Token
        config.headers.token = token; // 与 Vue 项目保持一致也添加一个 'token' 头 (如果后端也需要)
      }
      return { ...config };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response: any) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      // 检查响应数据中的401错误
      if (data && data.code === 401) {
        // message.error(data.msg || 'token失效，请重新登录');
        // 清除本地存储的token
        localStorage.removeItem('accessToken');
        // 使用React Router进行无刷新跳转
        history.push('/user/login');
        return Promise.reject(new Error('token失效'));
      }

      if (data?.success === false) {
        message.error('请求失败！');
      }
      return response;
    },
  ],
};
